import { useRecordIntrospectionQuery } from '@common/cache';
import { useEffect } from 'react';
import { useReportStore } from '@store';
import { Report } from './Report.tsx';

export const RecordsReport = () => {
  const { setIntrospection } = useReportStore();
  const { data } = useRecordIntrospectionQuery();

  useEffect(() => {
    if (data) {
      setIntrospection(data);
    }
  }, [data]);

  return <Report />;
};
